import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "reInspect",
  "use": "reInspect-usage",
  "viewBox": "0 0 49.44 59.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 49.44 59.7\" id=\"reInspect\"><title>资源 24</title><g data-name=\"图层 2\"><g data-name=\"图层 1\"><path d=\"M24.72 59.7C15.86 59.7 0 46.6 0 33.71V8.51l4.34-.05a30.14 30.14 0 0 0 9.46-2.08A42.65 42.65 0 0 0 22.05 2l2.63-2 2.57 1.87.11.07a46.62 46.62 0 0 0 8.26 4.44 29.87 29.87 0 0 0 9.47 2.07l4.29.05.06 25.2c0 12.9-15.86 26-24.72 26zM4.2 12.66v21.05C4.2 44 17.59 55.5 24.72 55.5S45.24 44 45.24 33.71l-.05-21.06H45a34.1 34.1 0 0 1-11-2.39 51.45 51.45 0 0 1-8.59-4.56l-.66-.48-.09.06a46.33 46.33 0 0 1-9.22 5 34.06 34.06 0 0 1-11 2.39z\" /><rect x=\"22.72\" y=\"18.35\" width=\"4\" height=\"23\" rx=\"2\" ry=\"2\" /><rect x=\"22.72\" y=\"20.35\" width=\"4\" height=\"19\" rx=\"2\" ry=\"2\" transform=\"rotate(90 24.72 29.85)\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/reInspect.svg
// module id = CDyZ
// module chunks = 6